import { LoadableAfterPaint } from '@confluence/loadable';

export const AnchorExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AnchorExtensionHandler" */ '../src/AnchorExtensionHandler.tsx'
			)
		).AnchorExtensionHandler,
});
